import React from 'react'
import styles from './Introduction.module.css'
import IntroductionCard from './IntroductionCard'

export default function Introduction() {
    const introductions = [
        {
            stepImageSp:
                '/pages/business/hotelslabo/introduction_step_sp_1.png',
            image: '/pages/business/hotelslabo/introduction_step_image_1.png',
            title: 'お問い合せ',
            description:
                '貴社の現状に合わせたプランをご案内いたします。まずはお気軽にお問い合わせください。',
        },
        {
            stepImageSp:
                '/pages/business/hotelslabo/introduction_step_sp_2.png',
            image: '/pages/business/hotelslabo/introduction_step_image_2.png',
            title: '求人作成',
            description:
                '管理画面より求人の作成を行なって頂きます。作成経験がない方でもスムーズに作成いただけます。',
        },
        {
            stepImageSp:
                '/pages/business/hotelslabo/introduction_step_sp_3.png',
            image: '/pages/business/hotelslabo/introduction_step_image_3.png',
            title: '運用開始/サポート',
            description:
                'プロ目線で求人内容のアドバイス等、採用のサポートを致します。自社運用型が初めての企業様も、安心して採用活動を進めて頂けます。',
        },
    ]

    return (
        <section id='introduction' className={styles.introduction}>
            <h1>導入の流れ</h1>
            <img
                className={styles.introductionStepPc}
                src='/pages/business/hotelslabo/introduction_step_pc.png'
                alt='導入の流れ'
            />
            <ul>
                {introductions.map((intro, index) => (
                    <IntroductionCard
                        key={index}
                        stepImageSp={intro.stepImageSp}
                        image={intro.image}
                        title={intro.title}
                        description={intro.description}
                    />
                ))}
            </ul>
        </section>
    )
}
